import { render, staticRenderFns } from "./StatisticeReportChart.vue?vue&type=template&id=ab881fda&scoped=true&"
import script from "./StatisticeReportChart.vue?vue&type=script&lang=js&"
export * from "./StatisticeReportChart.vue?vue&type=script&lang=js&"
import style0 from "./StatisticeReportChart.vue?vue&type=style&index=0&id=ab881fda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab881fda",
  null
  
)

export default component.exports